<template>
  <p class="is-size-6 has-text-secondary-grey has-text-centered m-t-4" :class="{ 'is-loading': isLoadingButton }">
    {{ $t('financialadvisor.pro-upsell-monthly-link-prompt') }}
    <a
      href="#"
      class="is-link has-text-weight-semibold"
      @click.prevent="onGetPlan"
      :data-e2e="FinancialAdvisorEstateCypressAttribute.modal.buttons.GET_MONTHLY_PLAN"
    >
      {{ $t('financialadvisor.pro-upsell-monthly-link-cta') }}
    </a>
  </p>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { FinancialAdvisorEstateCypressAttribute } from '@/modules/financialadvisor/constants/FinancialAdvisorEstateCypressAttribute';
import { FinancialAdvisorProUpsellPlanMixin } from '@/modules/financialadvisor/mixins/FinancialAdvisorProUpsellPlanMixin';

export default defineComponent({
  name: 'FinancialAdvisorProUpsellMonthlyPlanLink',
  mixins: [FinancialAdvisorProUpsellPlanMixin],
  components: {},
  static: {
    FinancialAdvisorEstateCypressAttribute
  }
});
</script>
